module.exports = __webpack_public_path__ + "static/media/samgatha.7d724454.png";